import Raven from 'raven-js';

import { useGetAllQuery } from '../../__generated__/chirp/com/hubspot/piesync/bridge/rpc/AppsRpc.hooks';

type TUseDataSyncAppsArgs = {
  skip?: boolean;
};

export const useDataSyncApps = (args?: TUseDataSyncAppsArgs) => {
  const { data, loading, error, networkStatus } = useGetAllQuery({
    onError: (err) => {
      Raven.captureException(err);
    },
    skip: args?.skip ?? false,
  });

  return {
    data: data?.apps || [],
    error,
    isLoading: loading,
    networkStatus,
  };
};
